document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.querySelector('.menu-toggle');
  const menuClose = document.querySelector('.menu-close');
  const mobileMenu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu__overlay');
  const siteHeader = document.querySelector('.site-header');
  const body = document.body;

  function isMobileMenuViewport() {
    return window.innerWidth <= 1024;
  }

  /* =========================================
     MOVE MOBILE MENU OUTSIDE STICKY HEADER
  ========================================= */
  if (mobileMenu && mobileMenu.parentNode !== body) {
    body.appendChild(mobileMenu);
  }

  if (overlay && overlay.parentNode !== body) {
    body.appendChild(overlay);
  }

  /* =========================================
     HEADER SCROLL STATE
  ========================================= */
  function updateHeaderScrollState() {
    if (!siteHeader) return;
    if (siteHeader.classList.contains('is-menu-open') && isMobileMenuViewport()) return;

    if (window.scrollY > 24) {
      siteHeader.classList.add('is-scrolled');
    } else {
      siteHeader.classList.remove('is-scrolled');
    }
  }

  /* =========================================
     MENU OPEN / CLOSE
  ========================================= */
  function openMenu() {
    if (!mobileMenu || !isMobileMenuViewport()) return;

    mobileMenu.classList.add('active');

    if (overlay) {
      overlay.classList.add('active');
    }

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'true');
    }

    if (siteHeader) {
      siteHeader.classList.add('is-menu-open');
      siteHeader.classList.remove('is-scrolled');
    }

    body.classList.add('mobile-menu-open');
  }

  function closeMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
    }

    if (overlay) {
      overlay.classList.remove('active');
    }

    if (menuToggle) {
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    if (siteHeader) {
      siteHeader.classList.remove('is-menu-open');
    }

    body.classList.remove('mobile-menu-open');
    updateHeaderScrollState();
  }

  function resetDesktopMenuState() {
    if (isMobileMenuViewport()) return;

    closeMenu();
  }

  /* =========================================
     MENU EVENTS
  ========================================= */
  if (menuToggle) {
    menuToggle.addEventListener('click', openMenu);
  }

  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
    }
  });

  /* =========================================
     MOBILE SUBMENU LEVEL 1
  ========================================= */
  const menuItems = document.querySelectorAll('.mobile-menu__item');

  menuItems.forEach((item) => {
    const trigger = item.querySelector('.mobile-menu__link');
    const submenu = item.querySelector('.mobile-submenu');

    if (!trigger || !submenu) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = item.classList.contains('is-open');

      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
        }
      });

      item.classList.toggle('is-open', !isOpen);
    });
  });

  /* =========================================
     MOBILE SUBMENU LEVEL 2
  ========================================= */
  const submenuChildren = document.querySelectorAll('.mobile-submenu__item--has-children');

  submenuChildren.forEach((item) => {
    const trigger = item.querySelector('.mobile-submenu__link');
    const submenu = item.querySelector('.mobile-submenu--level-2');

    if (!trigger || !submenu) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = item.classList.contains('is-open');
      const parentSubmenu = item.closest('.mobile-submenu');

      if (parentSubmenu) {
        const siblingItems = parentSubmenu.querySelectorAll(':scope > .mobile-submenu__item--has-children');

        siblingItems.forEach((sibling) => {
          if (sibling !== item) {
            sibling.classList.remove('is-open');
          }
        });
      }

      item.classList.toggle('is-open', !isOpen);
    });
  });

  /* =========================================
     MOBILE SOCIAL DROPDOWN
  ========================================= */
  const socialTrigger = document.querySelector('.mobile-menu__social-trigger');
  const socialDropdown = document.querySelector('.mobile-menu__social-dropdown');

  if (socialTrigger && socialDropdown) {
    socialTrigger.addEventListener('click', function () {
      const isOpen = socialDropdown.classList.toggle('is-open');
      socialTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* =========================================
     INIT
  ========================================= */
  updateHeaderScrollState();

  window.addEventListener('scroll', updateHeaderScrollState);

  window.addEventListener('resize', function () {
    resetDesktopMenuState();
    updateHeaderScrollState();
  });
});